import { render, staticRenderFns } from "./produceMouldInfo.pug?vue&type=template&id=795e7fcf&lang=pug&"
import script from "./produceMouldInfo.ts?vue&type=script&lang=ts&"
export * from "./produceMouldInfo.ts?vue&type=script&lang=ts&"
import style0 from "./produceMouldInfo.styl?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports